"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));
/**
 * Base class for all the custom related exceptions
 */

var AppException = /*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(AppException, _Error);
  function AppException() {
    (0, _classCallCheck2.default)(this, AppException);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AppException).apply(this, arguments));
  }
  return AppException;
}((0, _wrapNativeSuper2.default)(Error));
exports.default = AppException;